export default __webpack_public_path__ + "static/SRUS RT240 - Especification Del Producto y Datos Técnicos-cf505ee877dc4e10bdd1fd69ca8a8486.pdf";